import React from 'react';
import { Drawer, Divider, List, ListItem, ListItemIcon, ListItemText, Collapse } from '@material-ui/core';
import { MenuContacts, MenuCategory, MenuDraft, MenuChat, MenuRoom, MenuReservation, MenuPostPublished, MenuPostNew, Logout, MenuActivities, MenuTrainers, MenuReminders, MenuPosts, MenuSubscriptions, MenuAccesses, MenuBirthday, MenuMedicalExaminations } from '../ui-components/Icons';
import { ExpandLess, ExpandMore } from '@material-ui/icons';

interface IProps {
    classes: any;
    drawerOpen: boolean;
    handleDrawerClose: (e: any) => void;
    handleMenuSelection: (val: string) => void;
    logOut: (e) => void;
}

export const LeftDrawer = (props: IProps) => {

    const [openCollapse, setOpenCollapse] = React.useState(false);
    const [postCollapse, setPostCollapse] = React.useState(false);

    const handleOpenSettings = () => {
        setOpenCollapse(!openCollapse);
    }
    const handlePostCollpse = () => {
        setPostCollapse(!postCollapse);
    }

    const { classes, drawerOpen, handleDrawerClose, handleMenuSelection, logOut } = props;

    return (<Drawer className={classes.drawer}
        onClose={handleDrawerClose}
        //variant="persistent"
        anchor="left" open={drawerOpen}
        ModalProps={{
            BackdropProps: { invisible: true },

        }}

        classes={{
            paper: classes.drawerPaper,
            root: classes.drawerRoot
        }}>
        {/* <div className={classes.drawerHeader}>
            <Typography variant='h5'>MENU</Typography>
            <IconButton onClick={handleDrawerClose}>
                <Left />
            </IconButton>
        </div> */}
        {/* <Divider /> */}

        {/* <div className={classes.appBarSpacer} /> */}

        <List className={classes.drawerBody}>
            <ListItem button className={classes.routerLink} key="Contacts" onClick={() => handleMenuSelection('/private/Contacts')}>
                <ListItemIcon><MenuContacts fill="white" /></ListItemIcon>
                <ListItemText primary="Contatti" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="Reminders" onClick={() => handleMenuSelection('/private/Reminders')}>
                <ListItemIcon><MenuReminders fill="white" /></ListItemIcon>
                <ListItemText primary="Promemoria" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="MedicalExaminations" onClick={() => handleMenuSelection('/private/MedicalExaminations')}>
                <ListItemIcon><MenuMedicalExaminations fill="white" /></ListItemIcon>
                <ListItemText primary="Visite Mediche" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="Chat" onClick={() => handleMenuSelection('/private/Chat')}>
                <ListItemIcon><MenuChat fill="white" /></ListItemIcon>
                <ListItemText primary="Chat" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="Subscriptions" onClick={() => handleMenuSelection('/private/Subscriptions')}>
                <ListItemIcon><MenuSubscriptions fill="white" /></ListItemIcon>
                <ListItemText primary="Abbonamenti" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="activities" onClick={() => handleMenuSelection('/private/Activities')}>
                <ListItemIcon><MenuActivities fill="white" /></ListItemIcon>
                <ListItemText primary="Attività" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="access" onClick={() => handleMenuSelection('/private/Accesses')}>
                <ListItemIcon><MenuAccesses fill="white" /></ListItemIcon>
                <ListItemText primary="Accessi Utenti" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="reservation" onClick={handleOpenSettings}>
                <ListItemIcon>
                    <MenuReservation fill="white" />
                </ListItemIcon>
                <ListItemText primary="Prenotazioni" />
                {openCollapse ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={openCollapse} timeout="auto" unmountOnExit>
                <List component="div" dense style={{ paddingLeft: 25 }}>
                    <ListItem button className={classes.nested} onClick={() => handleMenuSelection('/private/Reservation')}>
                        <ListItemIcon style={{ minWidth: 30 }}>
                            <MenuRoom fill="white" />
                        </ListItemIcon>
                        <ListItemText primary="Accessi" />
                    </ListItem>
                    <ListItem button className={classes.nested} onClick={() => handleMenuSelection('/private/ActivityReservations')}>
                        <ListItemIcon style={{ minWidth: 30 }}>
                            <MenuActivities fill="white" />
                        </ListItemIcon>
                        <ListItemText primary="Attività" />
                    </ListItem>
                </List>
            </Collapse>

            <ListItem button className={classes.routerLink} key="room" onClick={() => handleMenuSelection('/private/Room')}>
                <ListItemIcon><MenuRoom fill="white" /></ListItemIcon>
                <ListItemText primary="Gestione Accessi" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="post" onClick={handlePostCollpse}>
                <ListItemIcon>
                    <MenuPosts fill="white" />
                </ListItemIcon>
                <ListItemText primary="Post" />
                {postCollapse ? <ExpandLess /> : <ExpandMore />}
            </ListItem>

            <Collapse in={postCollapse} timeout="auto" unmountOnExit>
                <List component="div" dense style={{ paddingLeft: 25 }}>
                    <ListItem button className={classes.nested} key="create" onClick={() => handleMenuSelection('/private/new')}>
                        <ListItemIcon style={{ minWidth: 30 }}>
                            <MenuPostNew fill="white" />
                        </ListItemIcon>
                        <ListItemText primary="Nuovo post" />
                    </ListItem>
                    <ListItem button className={classes.nested} key="drafts" onClick={() => handleMenuSelection('/private/drafts')}>
                        <ListItemIcon style={{ minWidth: 30 }}>
                            <MenuDraft fill="white" />
                        </ListItemIcon>
                        <ListItemText primary="Bozze" />
                    </ListItem>
                    <ListItem button className={classes.nested} key="sent" onClick={() => handleMenuSelection('/private/sent')}>
                        <ListItemIcon style={{ minWidth: 30 }}>
                            <MenuPostPublished fill="white" />
                        </ListItemIcon>
                        <ListItemText primary="Post inviati" />
                    </ListItem>
                </List>
            </Collapse>

            <ListItem button className={classes.routerLink} key="Birthdays" onClick={() => handleMenuSelection('/private/Birthdays')}>
                <ListItemIcon><MenuBirthday fill="white" /></ListItemIcon>
                <ListItemText primary="Compleanni" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="Tags" onClick={() => handleMenuSelection('/private/Tags')}>
                <ListItemIcon><MenuCategory fill="white" /></ListItemIcon>
                <ListItemText primary="Categorie" />
            </ListItem>

            <ListItem button className={classes.routerLink} key="Trainers" onClick={() => handleMenuSelection('/private/Trainers')}>
                <ListItemIcon><MenuTrainers fill="white" /></ListItemIcon>
                <ListItemText primary="Istruttori" />
            </ListItem>

            <Divider />

            <ListItem button key="logout" onClick={logOut}>
                <ListItemIcon><Logout fill="white" /></ListItemIcon>
                <ListItemText primary="Logout" />
            </ListItem>

        </List>
    </Drawer >)
}